import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import actions from '@/actions'
import useServerResponseToast from '@/core/hooks/useServerResponseToast'
import { users } from '@/http/api/users'

export function useUpdateCurrentUser({
  showToast = true,
}: { showToast?: boolean } = {}) {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const toast = useServerResponseToast('user.mutations.update')

  return useMutation({
    mutationFn: users.current.update,
    onSuccess: async () => {
      dispatch(actions.dashboard.clearAll())
      dispatch(actions.lecture.clearAll())
      dispatch(actions.quiz.clearAll())
      await dispatch(actions.user.get())
      await queryClient.invalidateQueries()
      if (showToast) {
        toast.success()
      }
    },
    onError: (error) => {
      if (showToast) {
        toast.error(error, { hideDescription: true })
      }
    },
  })
}
